import { useEffect, useState } from 'react'
import { Dialogs, useDialogs } from '../../sharedComponents/src/Contexts/DialogsContext'
import { useStoreState } from '../../store/hooks'
import { content } from './content'
import { FTUEDialog } from './FTUEDialog'

export const FTUE = () => {
    const { registerDialog, unregisterDialog } = useDialogs()
    const isDrawerMenuOpen = useStoreState((state) => state.isDrawerMenuOpen)
    const manualActiveFTUE = useStoreState((state) => state.manualActiveFTUE)
    const [activeFTUE, setActiveFTUE] = useState<string>('')
    const activeTab = useStoreState((state) => state.activeTab) // Current active tab for matchmaking drawer - 'New game' = 0 | 'Players' = 1 | 'Computer' = 2
    const userData = useStoreState((state) => state.userData)
    const currentLocation = window.location.pathname

    useEffect(() => {
        let timeout
        if (userData.userData?.ftue) {
            if (!isDrawerMenuOpen) {
                timeout = setTimeout(() => {
                    if (currentLocation === '/') {
                        setActiveFTUE(`/${activeTab}`)
                    } else {
                        setActiveFTUE(currentLocation)
                    }
                }, 100)
            }
        }
        return () => {
            clearTimeout(timeout)
        }
    }, [currentLocation, activeTab, userData.userData?.ftue, isDrawerMenuOpen])

    const activeContent = content[activeFTUE] || content[manualActiveFTUE]
    // const activeContent = content[manualActiveFTUE]

    useEffect(() => {
        if (!userData.userData) return

        if (activeContent && !userData.userData?.ftue[activeContent.key]) {
            registerDialog(Dialogs.FTUE, <FTUEDialog activeContent={activeContent} />)
        } else if (activeContent && manualActiveFTUE) {
            registerDialog(Dialogs.FTUE, <FTUEDialog activeContent={activeContent} />)
        } else {
            unregisterDialog(Dialogs.FTUE)
        }

        return () => {
            unregisterDialog(Dialogs.FTUE)
        }
    }, [activeContent, userData.userData, manualActiveFTUE, registerDialog, unregisterDialog])

    return null
}
